// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"388":"e427d2ce18ba0562","1350":"e4cd7812f560f694","1919":"943db3d00b620333","9952":"1ae1f21832dcc195","9961":"4ecf317cf4f9a6ed"}[chunkId] + ".css";
};